<script setup lang="ts" generic="T">
import { useFloatMenu } from '../FloatMenuContext'

interface Props {
  value?: T
  disabled?: boolean
  noCloseAfterSelect?: boolean
  active?: boolean
}

interface Emits {
  (event: 'select', value?: T): void
}
const props = defineProps<Props>()
const emits = defineEmits<Emits>()

const listItemId = randomID()

const { onSelect, id, itensClass } = useFloatMenu()

const handlerClick = () => {
  if (props.disabled)
    return
  emits('select', props.value)
  onSelect(props.value, props.noCloseAfterSelect)
}
</script>

<template>
  <li
    :id="`menuitem-${id}-${listItemId}`"
    class="float-menu-item hover:bg-grayLighter focus-visible:outline-none focus-visible:bg-grayLighter flex items-center gap-1 rounded p-2 text-xs leading-4.5 cursor-pointer"
    :class="[itensClass, {
      'opacity-50': props.disabled,
      'pointer-events-none': props.disabled,
      'bg-gray-lighter': props.active,
    }]"
    role="menuitem"
    @click="handlerClick"
  >
    <slot name="icon-wrapper">
      <div class="w-4 h-4 flex items-center justify-center">
        <slot name="icon">
          <div i-material-symbols:edit-outline w-3 h-3 />
        </slot>
      </div>
    </slot>

    <span flex items-center flex-1 :on-select="handlerClick">
      <slot />
    </span>
  </li>
</template>
